/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { channelsBulkJobsPost } from '../fn/channels-bulk-jobs/channels-bulk-jobs-post';
import { ChannelsBulkJobsPost$Params } from '../fn/channels-bulk-jobs/channels-bulk-jobs-post';
import { HalJson } from '../models/hal-json';

@Injectable({ providedIn: 'root' })
export class ChannelsBulkJobsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `channelsBulkJobsPost()` */
  static readonly ChannelsBulkJobsPostPath = '/channels/bulk-jobs';

  /**
   * Bulk create job availability OOS.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `channelsBulkJobsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  channelsBulkJobsPost$Response(params: ChannelsBulkJobsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'jobId'?: string;
'status'?: string;
}>> {
    return channelsBulkJobsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Bulk create job availability OOS.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `channelsBulkJobsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  channelsBulkJobsPost(params: ChannelsBulkJobsPost$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
'jobId'?: string;
'status'?: string;
}> {
    return this.channelsBulkJobsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
'jobId'?: string;
'status'?: string;
}>): {
'_links'?: HalJson;
'jobId'?: string;
'status'?: string;
} => r.body)
    );
  }

}
